<template>
  <div class="user-management anim-fade-in-up">
    <!-- 筛选 + 操作栏 -->
    <div class="content-card filter-bar">
      <div class="filter-left">
        <el-input v-model="searchKeyword" placeholder="请输入用户名查询" size="small" style="width: 200px;" clearable @keyup.enter.native="handleSearch" />
        <el-button size="small" @click="handleSearch">查询</el-button>
        <el-button size="small" @click="handleReset">重置</el-button>
      </div>
      <div class="filter-right">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">添加用户</el-button>
        <el-button type="danger" size="small" icon="el-icon-delete" :disabled="selectedRows.length === 0" @click="batchDelete">批量删除</el-button>
      </div>
    </div>

    <!-- 数据表 -->
    <div class="content-card" style="padding: 4px;">
      <el-table :data="displayList" border stripe v-loading="loading" size="small" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" />
        <el-table-column prop="userId" label="账号" min-width="90" />
        <el-table-column prop="userName" label="用户名" min-width="100" />
        <el-table-column prop="phone" label="手机号" min-width="110" />
        <el-table-column prop="email" label="邮箱" min-width="150" show-overflow-tooltip />
        <el-table-column prop="researchGroup" label="所属课题组" min-width="130" show-overflow-tooltip />
        <el-table-column label="角色" min-width="80">
          <template slot-scope="{row}">
            <el-tag
              :type="row.role==='管理员'?'warning':'success'"
              size="small"
              style="cursor: pointer;"
              @click="switchRole(row)"
            >{{ row.role }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="90">
          <template slot-scope="{row}">
            <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="openEditDialog(row)" />
            <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteUser(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="editMode ? '编辑用户' : '新增用户'" width="520px" append-to-body :close-on-click-modal="false">
      <el-form :model="userForm" :rules="userRules" ref="userFormRef" label-width="90px">
        <el-form-item label="账号" prop="userId">
          <el-input v-model="userForm.userId" :disabled="editMode" maxlength="6" show-word-limit placeholder="6位数字账号" />
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="userForm.userName" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item v-if="!editMode" label="密码" prop="userPassword">
          <el-input v-model="userForm.userPassword" type="password" show-password placeholder="请输入密码" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="userForm.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" placeholder="请输入邮箱" />
        </el-form-item>
        <el-form-item label="所属课题组" prop="researchGroup">
          <el-input v-model="userForm.researchGroup" placeholder="请输入所属课题组" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUser" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<style scoped>
.page-title {
  font-family: var(--font-display);
  font-size: 1.5rem; font-weight: 500;
  color: var(--text-primary); margin: 0 0 18px; letter-spacing: 0.04em;
}

.content-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.filter-bar {
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 20px; margin-bottom: 16px;
  flex-wrap: wrap; gap: 10px;
}
.filter-left { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.filter-right { display: flex; gap: 10px; align-items: center; flex-shrink: 0; }

</style>

<script>
export default {
  data() {
    return {
      userList: [], displayList: [], loading: false, searchKeyword: '', selectedRows: [],
      currentUserId: '', dialogVisible: false, editMode: false, submitting: false,
      userForm: { userId: '', userName: '', userPassword: '', phone: '', email: '', researchGroup: '' },
      userRules: {
        userId: [{ required: true, message: '账号不能为空', trigger: 'blur' }, { pattern: /^\d{6}$/, message: '6位数字', trigger: 'blur' }],
        userName: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
        userPassword: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
        phone: [{ pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        email: [{ type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }]
      }
    }
  },
  created() { this.fetchUserList(); this.fetchCurrentUser(); },
  methods: {
    async fetchUserList() {
      this.loading = true;
      try {
        const resp = await this.$axios.get('/user/list');
        if (resp.data.code === 0) { this.userList = resp.data.data || []; this.displayList = this.userList; }
      } catch (e) { console.error(e); } finally { this.loading = false; }
    },
    handleSearch() {
      if (!this.searchKeyword) { this.displayList = this.userList; return; }
      const kw = this.searchKeyword.toLowerCase();
      this.displayList = this.userList.filter(u => (u.userName || '').toLowerCase().includes(kw));
    },
    handleReset() { this.searchKeyword = ''; this.displayList = this.userList; },
    handleSelectionChange(rows) { this.selectedRows = rows; },
    openAddDialog() {
      this.editMode = false; this.dialogVisible = true;
      this.userForm = { userId: '', userName: '', userPassword: '', phone: '', email: '', researchGroup: '' };
      this.$nextTick(() => { if (this.$refs.userFormRef) this.$refs.userFormRef.clearValidate(); });
    },
    openEditDialog(row) {
      this.editMode = true; this.dialogVisible = true;
      this.userForm = { userId: row.userId, userName: row.userName, userPassword: '', phone: row.phone || '', email: row.email || '', researchGroup: row.researchGroup || '' };
      this.$nextTick(() => { if (this.$refs.userFormRef) this.$refs.userFormRef.clearValidate(); });
    },
    async submitUser() {
      const valid = await this.$refs.userFormRef.validate().catch(() => false);
      if (!valid) return;
      this.submitting = true;
      try {
        const url = this.editMode ? '/user/update' : '/user/register';
        const method = this.editMode ? 'put' : 'post';
        const resp = await this.$axios[method](url, this.userForm);
        if (resp.data.code === 0) { this.$message.success(this.editMode ? '更新成功' : '添加成功'); this.dialogVisible = false; this.fetchUserList(); }
        else { this.$message.error(resp.data.msg || '操作失败'); }
      } catch (e) { this.$message.error('操作失败'); } finally { this.submitting = false; }
    },
    async switchRole(row) {
      if (row.userId === this.currentUserId) { this.$message.warning('不能切换自己的角色'); return; }
      try {
        const newRole = row.role === '管理员' ? '用户' : '管理员';
        await this.$confirm(`确定将「${row.userName}」切换为「${newRole}」吗？`, '切换角色', { type: 'warning' });
        const resp = await this.$axios.put('/user/changeRole', { userId: row.userId, role: newRole });
        if (resp.data.code === 0) { this.$message.success('角色已修改'); this.fetchUserList(); }
        else { this.$message.error(resp.data.msg || '操作失败'); }
      } catch (e) { if (e !== 'cancel') { this.$message.error('操作失败'); } }
    },
    async batchDelete() {
      if (this.selectedRows.length === 0) return;
      const names = this.selectedRows.map(r => r.userName).join('、');
      try {
        await this.$confirm(`确定删除选中的 ${this.selectedRows.length} 名成员吗？（${names}）`, '批量删除', { type: 'warning' });
        for (const row of this.selectedRows) {
          await this.$axios.delete(`/user/delete/${row.userId}`);
        }
        this.$message.success(`已删除 ${this.selectedRows.length} 名成员`);
        this.selectedRows = [];
        this.fetchUserList();
      } catch (e) { if (e !== 'cancel') { this.$message.error('批量删除失败'); } }
    },
    async fetchCurrentUser() {
      try {
        const resp = await this.$axios.get('/adm/info');
        if (resp.data.code === 0) { this.currentUserId = (resp.data.data || {}).userId || ''; }
      } catch (e) { console.warn('获取当前用户信息失败:', e); }
    },
    async deleteUser(row) {
      try {
        await this.$confirm(`确定删除用户「${row.userName}」吗？`, '删除用户', { type: 'warning' });
        const resp = await this.$axios.delete(`/user/delete/${row.userId}`);
        if (resp.data.code === 0) { this.$message.success('已删除'); this.fetchUserList(); }
        else { this.$message.error(resp.data.msg || '删除失败'); }
      } catch (e) { if (e !== 'cancel') { this.$message.error('删除失败'); } }
    }
  }
}
</script>
